import { defineTour } from '@lopettia/simul';

/**
 * Agent configurator — tour through agent runtime toggles + the flow
 * canvas (chain editor). Mirrors docs/manuals/05-agent-configurator.md.
 */
export const agentConfiguratorTour = defineTour({
  name: 'Agent configuration',
  description:
    'Per-tenant agent runtime toggles and the chain editor flow canvas.',
  steps: [
    {
      id: 'ac-agents',
      kind: 'navigate',
      target: '[data-tour-id="nav-agents"]',
      toUrl: '/admin/agents',
      prelude: { goto: '/dashboard' },
      message:
        '**Agents** lists every agent type Kairos supports. Toggle them on '
        + 'or off per tenant.',
      advanceOn: 'navigate',
    },
    {
      id: 'ac-chains',
      kind: 'navigate',
      target: '[data-tour-id="nav-chains"]',
      toUrl: '/admin/chains',
      message:
        'Chains compose agents into reusable flows. The chain list is your '
        + 'starting point.',
      advanceOn: 'navigate',
    },
    {
      id: 'ac-canvas',
      kind: 'info',
      target: '[data-tour-id="chains-list"]',
      message:
        'Open any chain to drop into the **flow canvas** — drag nodes, wire '
        + 'edges, set conditions.',
      advanceOn: 'manual',
    },
  ],
});

export default agentConfiguratorTour;
